// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"VirifyCard_inputWrapper__1qSly","input":"VirifyCard_input__1we3G","button":"VirifyCard_button__1uSut"};